/* eslint-disable react-hooks/exhaustive-deps */
import {
  CaretDownFilled,
  CaretUpFilled,
  CloseOutlined,
  MinusOutlined,
  PlusOutlined,
} from '@ant-design/icons';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { WidgetLoader } from 'datastake-daf/dist/components';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { renderLevel } from './helper';
import { MapContStyle as Style } from './style';
import useMapHelper, { getTitle } from './mapHelper';
import { DashboardService } from '../../../../../services';
import { useCountry } from '../../../../../helpers/map';
import { getOptionLabel } from '../../../../DynamicViewNew/helper';
import { formatClassname } from 'datastake-daf/src/helpers/ClassesHelper';
import ComponentWithFocus from '../../../../../screens/Analysis/components/component-with-focus';

export const waitFor = (delay) => new Promise(resolve => setTimeout(resolve, delay));

const MapWidget = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();
  const [dataSource, setDataSource] = useState();
  const container = useRef();
  const [emptyShown, setEmptyShown] = useState(true);
  const options = useSelector((state) => state.project.data.options) || {};
  const { getCountry } = useCountry();

  const {
    activeMarker,
    zoomHandler,
    zoomOutHandler,
    moveDownHandler,
    moveUpHandler,
    showSider,
  } = useMapHelper({ data, container, t });

  const fetchData = async () => {
    try {
      const _res = await DashboardService.getPmeProject({
        widget: 'supplyChainMap',
      });

      const _data = _res?.data?.supplyChainMap || [];
      const villages = [];
      const mineSites = {};
      const emptyMineSites = [];

      _data.forEach((data) => {
        if (data.village) {
          const foundVillage = mineSites[data.village.id]
          if (foundVillage) {
            mineSites[data.village.id].push(data);
          } else {
            villages.push(data.village);
            mineSites[data.village.id] = [data];
          }
        } else {
          emptyMineSites.push(data);
        }
      });

      const mappedData = villages.map((v) => ({
        associatedVillage: v,
        mineSites: mineSites[v.id] || [],
      }));

      const other = { mineSites: emptyMineSites };
      setDataSource(_data);
      setData([...mappedData, other]);
      setLoading(false);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const sider = useMemo(() => {
    return (
      <div className={formatClassname(['sider', showSider && 'toggled'])}>
        {!!activeMarker && (
          <div className="sider-body">
            <h2>
              {getTitle(t, activeMarker.type)}
            </h2>
            <h3>{activeMarker?.data?.name || '-'}</h3>
            <div className='row-items'>
              <div className='row-item'>
                <label>{t('Country')}</label>
                <p>
                  {getCountry(activeMarker?.data?.country)}
                </p>
              </div>
              <div className='row-item'>
                <label>{t('Province')}</label>
                <p>
                  {renderLevel(activeMarker?.data, 'administrativeLevel1')}
                </p>
              </div>
              <div className='row-item'>
                <label>{t('Territory')}</label>
                <p>
                  {renderLevel(activeMarker?.data, 'administrativeLevel2')}
                </p>
              </div>
              {(activeMarker && activeMarker.type === 'mineSite') && (
                <>
                  {/* <div className='row-item'>
                    <label>{t('Type of mining operations')}</label>
                    <p>
                      Artisanal and small-scale mining
                    </p>
                  </div> */}
                  <div className='row-item'>
                    <label>{t('Operator')}</label>
                    <p>
                      {activeMarker?.data?.operator?.name || '-'}
                    </p>
                  </div>
                  <div className='row-item'>
                    <label>{t('Products')}</label>
                    <div className='tags'>
                      {(activeMarker?.data?.products || []).map((p, i) => (
                        <div className='tag' key={`${p}-${i}`}>
                          {getOptionLabel((options.minerals || []), p) || '-'}
                        </div>
                      ))}
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }, [activeMarker, t, showSider, options]);

  const [closed, setClosed] = useState(false);
  const actions = useMemo(() => ({
    closed,
    setClosed,
    unFocus: () => { },
  }), [closed]);

  const isEmpty = useMemo(() => loading ? false : !dataSource?.length, [dataSource, loading])

  return (
    <Style>
      <ComponentWithFocus style={{ zIndex: 500 }} actions={actions}>
        <div
          className="map"
          style={{ flex: 1, height: '100%' }}
          ref={container}
        />
      </ComponentWithFocus>
      <div
        className="map-handlers"
      >
        <button onClick={zoomHandler}>
          <PlusOutlined />
        </button>
        <button onClick={zoomOutHandler}>
          <MinusOutlined />
        </button>
        <button onClick={moveUpHandler} className="up">
          <CaretUpFilled />
        </button>
        <button onClick={moveDownHandler} className="down">
          <CaretDownFilled />
        </button>
      </div>
      {isEmpty && (
        <div className={formatClassname(['empty-box', !emptyShown && 'closed'])}>
          <div className="close-row">
            <CloseOutlined onClick={() => setEmptyShown(false)} />
          </div>

          <div className="header-row">
            <img alt="treasure-map" src="/assets/images/map/treasure-map.png" />
            <h4>{t('Project Map')}</h4>
          </div>

          <p>
            {t('Displayed locations are based on information available in this project, and data settings.')}
          </p>

        </div>
      )}

      {loading && (
        <WidgetLoader style={{ zIndex: 501, background: 'white' }} />
      )}

      {sider}
    </Style>
  );
}

export default MapWidget;
